// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3bcp-","label":"Section_label__xcDv4","contentWrap":"Section_contentWrap__2Ylrm","footer":"Section_footer__RKKyP","footerInner":"Section_footerInner__3Jlwh"};